import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonios } from '../data/tomos';
export function Testimonials() {
  return <section className="w-full bg-white py-14 sm:py-20" data-id="element-93" data-mp="3krp59519wxqc">
      <div className="mx-auto max-w-5xl px-5" data-id="element-94" data-mp="3fzdzvmnrkjqe">
        <h2 className="max-w-2xl text-2xl font-black leading-tight tracking-tight text-ink sm:text-[2rem]" data-id="element-95" data-mp="3fy2zzxxfvw4k">
          Madres y padres que ya durmieron tranquilos
        </h2>

        <div className="mt-10 grid items-stretch gap-8 md:grid-cols-2" data-id="element-96" data-mp="3700q0svq9t55">
          {testimonios.map(t => <figure key={t.nombre} className="flex h-full flex-col rounded-2xl border border-paper-line p-7" data-id="element-97" data-mp="31z3davthlrb1">
              <div className="flex gap-0.5 text-flame" aria-label="5 de 5 estrellas" data-id="element-98" data-mp="2s1qbwxg1qefv">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4" fill="currentColor" aria-hidden="true" data-id="element-99" data-mp="v8555k5bgowg" data-mpi={i} />)}
              </div>
              <blockquote className="mt-4 text-lg font-medium leading-relaxed text-ink" data-id="element-100" data-mp="h8ayfe0pcrr8">
                “{t.cita}”
              </blockquote>
              <figcaption className="mt-auto flex items-center gap-3 pt-6" data-id="element-101" data-mp="78k4bdg20ero">
                <img src={t.foto} alt="" className="h-11 w-11 rounded-full object-cover" data-id="element-102" data-mp="c6ll1rq0c1zz" />
                <span className="text-sm leading-tight" data-id="element-103" data-mp="zx7rxfo9zg8e">
                  <span className="block font-bold text-ink" data-id="element-104" data-mp="14vskcsxacvma">{t.nombre}</span>
                  <span className="block text-ink-muted" data-id="element-105" data-mp="q6wcavv8bilo">{t.detalle}</span>
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}